/**
 * frontend/src/utils/destinatarios.ts
 * ====================================
 * A quién se envía el reporte. Hace falta para enviar, no para conciliar: sin
 * destinatarios, el resultado se revisa y se descarga en pantalla. El servidor
 * no tiene un destinatario por defecto.
 *
 * Replica la regla de `src/comun/destinatarios.py` para avisar antes de ir al
 * servidor. La que decide es la del servidor.
 */

const DIRECCION = /^[^@\s,;]+@[^@\s,;]+\.[^@\s,;.]+$/;
const SEPARADORES = /[,;\s]+/;

export const SIN_DESTINATARIOS =
  "Indique en Preferencias a quién se envía el reporte: sin destinatarios, " +
  "no se puede enviar por correo.";

/**
 * Las direcciones que no lo son, en un mensaje que las nombra; `null` si
 * todas lo son. Una lista vacía no tiene direcciones inválidas: esa falta la
 * avisa quien llama, con `SIN_DESTINATARIOS`.
 */
export function direccionesInvalidas(texto: string): string | null {
  const invalidas = texto.split(SEPARADORES).filter((p) => p && !DIRECCION.test(p));
  if (invalidas.length === 0) return null;

  return (
    (invalidas.length === 1
      ? "Esta dirección no es válida: "
      : "Estas direcciones no son válidas: ") +
    invalidas.join(", ") + "."
  );
}

/**
 * Lo que impide iniciar: solo una dirección mal escrita. Sin destinatarios se
 * concilia igual; se piden al enviar.
 */
export function problemaAlIniciar(texto: string): string | null {
  const invalidas = direccionesInvalidas(texto);
  return invalidas && `Revise los destinatarios en Preferencias. ${invalidas}`;
}

/** Lo que impide enviar el reporte por correo, o `null` si no hay. */
export function problemaDeDestinatarios(texto: string): string | null {
  if (!texto.split(SEPARADORES).some(Boolean)) return SIN_DESTINATARIOS;
  const invalidas = direccionesInvalidas(texto);
  return invalidas && `Revise los destinatarios en Preferencias. ${invalidas}`;
}
